export default [
  {
    name: 'signin',
    path: '/auth/signin',
    component: () => import('@modules/auth/components/signin-page.vue'),
    meta: { unauth: true },
  },
  {
    name: 'signup',
    path: '/auth/signup',
    component: () => import('@modules/auth/components/signup-page.vue'),
    meta: { unauth: true },
  },
  {
    name: 'forgotPassword',
    path: '/auth/forgot-password',
    component: () => import('@modules/auth/components/forgot-password-page.vue'),
    meta: { unauth: true },
  },
  {
    name: 'emailUnverified',
    path: '/auth/email-unverified',
    component: () => import('@modules/auth/components/email-unverified-page.vue'),
    meta: { auth: true, emailAlreadyVerified: true },
  },
  {
    name: 'emptyPermissions',
    path: '/auth/empty-permissions',
    component:() => import('@modules/auth/components/empty-permissions-page.vue'),
    meta: { auth: true, notEmptyPermissions: true },
  },
  {
    name: '',
    path: '',
    component:() => import('@modules/layout/components/layout.vue'),
    meta: { auth: true },
    children: [
      {
        name: 'editProfile',
        path: '/auth/edit-profile',
        component:() => import('@modules/auth/components/profile-form-page.vue'),
        meta: { auth: true },
      },
    ],
  },
  {
    name: 'inviteUser',
    path: '/auth/invite-user',
    component:() => import('@modules/auth/components/download-app-page.vue'),
    meta: { unauth: true },
  },
  {
    name: 'infoPasswordReset',
    path: '/auth/info-password-reset',
    component: () => import('@modules/auth/components/info-password-reset-page.vue'),
    meta: { unauth: true },
  },
  {
    name: 'infoEmailVerification',
    path: '/auth/info-email-verification',
    component: () => import('@modules/auth/components/info-email-verification-page.vue'),
    meta: { unauth: true },
  },
];
